import { render, staticRenderFns } from "./ChangeGeolocation.vue?vue&type=template&id=6d6266ee&"
import script from "./ChangeGeolocation.vue?vue&type=script&lang=js&"
export * from "./ChangeGeolocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports